import ar from './locales/ar.mjs';
export { default as ar } from './locales/ar.mjs';
import az from './locales/az.mjs';
export { default as az } from './locales/az.mjs';
import bg from './locales/bg.mjs';
export { default as bg } from './locales/bg.mjs';
import bs from './locales/bs.mjs';
export { default as bs } from './locales/bs.mjs';
import ca from './locales/ca.mjs';
export { default as ca } from './locales/ca.mjs';
import cs from './locales/cs.mjs';
export { default as cs } from './locales/cs.mjs';
import da from './locales/da.mjs';
export { default as da } from './locales/da.mjs';
import de from './locales/de.mjs';
export { default as de } from './locales/de.mjs';
import el from './locales/el.mjs';
export { default as el } from './locales/el.mjs';
import en from './locales/en.mjs';
export { default as en } from './locales/en.mjs';
import es from './locales/es.mjs';
export { default as es } from './locales/es.mjs';
import fa from './locales/fa.mjs';
export { default as fa } from './locales/fa.mjs';
import fi from './locales/fi.mjs';
export { default as fi } from './locales/fi.mjs';
import fr from './locales/fr.mjs';
export { default as fr } from './locales/fr.mjs';
import fy from './locales/fy.mjs';
export { default as fy } from './locales/fy.mjs';
import he from './locales/he.mjs';
export { default as he } from './locales/he.mjs';
import hr from './locales/hr.mjs';
export { default as hr } from './locales/hr.mjs';
import hu from './locales/hu.mjs';
export { default as hu } from './locales/hu.mjs';
import id from './locales/id.mjs';
export { default as id } from './locales/id.mjs';
import is from './locales/is.mjs';
export { default as is } from './locales/is.mjs';
import it from './locales/it.mjs';
export { default as it } from './locales/it.mjs';
import ja from './locales/ja.mjs';
export { default as ja } from './locales/ja.mjs';
import kk from './locales/kk.mjs';
export { default as kk } from './locales/kk.mjs';
import ko from './locales/ko.mjs';
export { default as ko } from './locales/ko.mjs';
import lt from './locales/lt.mjs';
export { default as lt } from './locales/lt.mjs';
import lv from './locales/lv.mjs';
export { default as lv } from './locales/lv.mjs';
import mn from './locales/mn.mjs';
export { default as mn } from './locales/mn.mjs';
import nb from './locales/nb.mjs';
export { default as nb } from './locales/nb.mjs';
import nl from './locales/nl.mjs';
export { default as nl } from './locales/nl.mjs';
import pl from './locales/pl.mjs';
export { default as pl } from './locales/pl.mjs';
import pt from './locales/pt.mjs';
export { default as pt } from './locales/pt.mjs';
import ro from './locales/ro.mjs';
export { default as ro } from './locales/ro.mjs';
import ru from './locales/ru.mjs';
export { default as ru } from './locales/ru.mjs';
import sk from './locales/sk.mjs';
export { default as sk } from './locales/sk.mjs';
import sl from './locales/sl.mjs';
export { default as sl } from './locales/sl.mjs';
import sr from './locales/sr.mjs';
export { default as sr } from './locales/sr.mjs';
import sv from './locales/sv.mjs';
export { default as sv } from './locales/sv.mjs';
import tet from './locales/tet.mjs';
export { default as tet } from './locales/tet.mjs';
import tg from './locales/tg.mjs';
export { default as tg } from './locales/tg.mjs';
import th from './locales/th.mjs';
export { default as th } from './locales/th.mjs';
import tr from './locales/tr.mjs';
export { default as tr } from './locales/tr.mjs';
import uk from './locales/uk.mjs';
export { default as uk } from './locales/uk.mjs';
import uz from './locales/uz.mjs';
export { default as uz } from './locales/uz.mjs';
import vi from './locales/vi.mjs';
export { default as vi } from './locales/vi.mjs';
import zh from './locales/zh.mjs';
export { default as zh } from './locales/zh.mjs';
import zhTW from './locales/zh-TW.mjs';
export { default as zhTW } from './locales/zh-TW.mjs';
export * from './i18n.mjs';
export * from './formatters.mjs';

// packages/i18n/src/index.ts
var locales = {
  ar,
  az,
  bg,
  bs,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fa,
  fi,
  fr,
  fy,
  he,
  hr,
  hu,
  id,
  it,
  ja,
  kk,
  ko,
  lt,
  lv,
  nb,
  nl,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  tet,
  tg,
  th,
  tr,
  uk,
  uz,
  vi,
  zh,
  "zh-TW": zhTW,
  is,
  mn
};

export { locales };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map